export const wa = {
  green: '#008069',
  send: '#00a884',
  bubbleOut: '#d9fdd3',
  bubbleIn: '#ffffff',
  wallpaper: '#efeae2',
  header: '#f0f2f5',
  text: '#111b21',
  meta: '#667781',
  icon: '#54656f',
  tick: '#8696a0',
  tickRead: '#53bdeb',
  border: '#d1d7db',
  unread: '#25d366',
  fail: '#ea0038',
};

const AVATAR_COLORS = ['#00a884', '#53bdeb', '#7f66ff', '#ff6b6b', '#ffb347', '#25d366', '#a695e7'];

export function avatarColor(seed) {
  const value = String(seed || '');
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) hash = (hash + value.charCodeAt(i)) % AVATAR_COLORS.length;
  return AVATAR_COLORS[hash];
}

export function initials(name) {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '#';
  return parts.slice(0, 2).map((part) => part[0]).join('').toUpperCase();
}

export const QUICK_REACTIONS = ['👍', '❤️', '😂', '😮', '😢', '🙏'];
